import { type PropsWithChildren, useMemo } from 'react';

import useSelector from '@app/hooks/useSelector';
import { NavigationPanelContext } from './NavigationPanelContext';

const NavigationPanelProvider = ({ children }: PropsWithChildren) => {
    // TODO: Replace with API calls
    const project = useSelector((state) => state.project);
    const userRights = useSelector((state) => state.userRights);
    const branch = useSelector((state) => state.branch);
    const badges = useSelector((state) => state.badges);
    const features = useSelector((state) => state.features);
    const session = useSelector((state) => state.session);
    const team = useSelector((state) => state.team);

    const value = useMemo(
        () => ({
            project,
            userRights,
            branch,
            badges,
            features,
            session,
            team,
        }),
        [project, userRights, branch, badges, features, session, team],
    );

    return <NavigationPanelContext.Provider value={value}>{children}</NavigationPanelContext.Provider>;
};

export default NavigationPanelProvider;
